<template>
  <div>
    <input type="hidden" name="equipment_id" :value="equipmentId" />
    <input type="hidden" name="bookable_id" :value="bookableId" />
    <input v-if="mode !== 'slot'" type="hidden" name="start_at" :value="dateRange?.start" />
    <input v-if="mode !== 'slot'" type="hidden" name="end_at" :value="dateRange?.end" />
    <input type="hidden" name="registration_id" :value="registrationId" />
  </div>
</template>

<script setup>
/**
 * The payload actually posted by the surrounding <form>. Shared by the create and edit screens so
 * both submit exactly the same fields. In slot mode the dates come from the slot, server-side.
 */
defineProps({
  mode: {
    type: String,
    required: true
  },
  equipmentId: {
    type: [Number, String],
    default: null
  },
  bookableId: {
    type: [Number, String],
    default: null
  },
  dateRange: {
    type: Object,
    default: null
  },
  registrationId: {
    type: [Number, String],
    default: null
  }
});
</script>
